"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Settings/Org/InfoTab/StopLineSection/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);




var _noticeBar = require('web/services/context/noticeBar');
var _Form = require('web/components/Form');
var _useOrgSMSStopLine = require('./useOrgSMSStopLine');


var _stopLine = require('./stopLine');

const PREVIEW_MESSAGE = '…your appointment is tomorrow at 9.'






const StopLineEditor = ({ setting, onSave }) => {
  const [isEnabled, setIsEnabled] = _react.useState.call(void 0, setting.Enabled)
  const [text, setText] = _react.useState.call(void 0, setting.Text)
  const [isSaving, setIsSaving] = _react.useState.call(void 0, false)
  const [saveError, setSaveError] = _react.useState(null)

  // A save returns the stored (trimmed) setting; show that.
  _react.useEffect.call(void 0, () => {
    setIsEnabled(setting.Enabled)
    setText(setting.Text)
  }, [setting])

  const onToggle = _react.useCallback.call(void 0, (v) => {
    setIsEnabled(v)
    setSaveError(null)
  }, [])
  const onChangeText = _react.useCallback.call(void 0, (e) => {
    setText(e.target.value)
    setSaveError(null)
  }, [])

  const { showSuccessBar } = _noticeBar.useNoticeBar.call(void 0, )
  const line = _stopLine.normalizeStopLine.call(void 0, text)
  const blocker = _stopLine.stopLineSaveBlocker.call(void 0, isEnabled, text, setting.MaxLength)
  // The keyword hint sits under the field; other blockers beside Save.
  const isMissingKeyword = blocker === _stopLine.STOP_LINE_KEYWORD_HINT
  const isDirty = isEnabled !== setting.Enabled || line !== setting.Text

  const save = _react.useCallback.call(void 0, () => {
    setIsSaving(true)
    setSaveError(null)
    onSave(isEnabled, line)
      .then(() => showSuccessBar('Opt-out line saved'))
      .catch(e => setSaveError(_stopLine.stopLineSaveError.call(void 0, e)))
      .finally(() => setIsSaving(false))
  }, [onSave, isEnabled, line, showSuccessBar])

  const counterId = _react.useId.call(void 0, )
  const keywordHintId = _react.useId.call(void 0, )
  const previewId = _react.useId.call(void 0, )

  return (
    _react2.default.createElement(_react2.default.Fragment, null
      , _react2.default.createElement(_Form.Toggle, {
        className: "settings--org-info--stop-line--toggle",
        label: "Add the opt-out line"   ,
        isChecked: isEnabled,
        onChange: onToggle, __self: this, __source: {fileName: _jsxFileName, lineNumber: 63}}
      )
      , _react2.default.createElement(_Form.InputSectionWrapper, {
        title: "Opt-out line" ,
        className: "settings--org-info--section", __self: this, __source: {fileName: _jsxFileName, lineNumber: 69}}

        , _react2.default.createElement(_Form.TextInput, {
          value: text,
          onChange: onChangeText,
          placeholder: setting.DefaultText,
          hasError: _stopLine.stopLineLength.call(void 0, text) > setting.MaxLength || isMissingKeyword,
          'aria-describedby': isMissingKeyword ? `${counterId} ${keywordHintId}` : counterId,
          className: "blm-input-section--input", __self: this, __source: {fileName: _jsxFileName, lineNumber: 73}}
        )
      )
      , _react2.default.createElement('span', { id: counterId, className: "settings--org-info--stop-line--counter", __self: this, __source: {fileName: _jsxFileName, lineNumber: 82}}
        ,  `${_stopLine.stopLineLength.call(void 0, text)}/${setting.MaxLength}` 
      )
      ,  isMissingKeyword && (
        _react2.default.createElement('span', { id: keywordHintId, className: "settings--org-info--stop-line--keyword-hint", __self: this, __source: {fileName: _jsxFileName, lineNumber: 86}}
          ,  _stopLine.STOP_LINE_KEYWORD_HINT 
        )
      )
      , _react2.default.createElement('figure', { className: "settings--org-info--stop-line--preview", 'aria-labelledby': previewId, __self: this, __source: {fileName: _jsxFileName, lineNumber: 90}}
        , _react2.default.createElement('figcaption', { id: previewId, className: "settings--org-info--stop-line--preview-title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 91}}, "Preview"

        )
        , _react2.default.createElement('div', { className: "settings--org-info--stop-line--preview-bubble", __self: this, __source: {fileName: _jsxFileName, lineNumber: 94}}
          , _react2.default.createElement('p', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 95}},  PREVIEW_MESSAGE )
          ,  isEnabled && line && _react2.default.createElement('p', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 96}},  line ) 
        )
      )
      ,  saveError && (
        _react2.default.createElement('span', { role: "alert", className: "settings--org-info--stop-line--error", __self: this, __source: {fileName: _jsxFileName, lineNumber: 100}},  saveError )
      )
      , _react2.default.createElement('div', { className: "settings--org-info--stop-line--actions", __self: this, __source: {fileName: _jsxFileName, lineNumber: 102}}
        , _react2.default.createElement(_Form.Button, {
          ariaLabel: "Save opt-out line"  ,
          isDisabled: !!blocker || !isDirty,
          isLoading: isSaving,
          onClick: save, __self: this, __source: {fileName: _jsxFileName, lineNumber: 103}}
, "Save"

        )
        ,  blocker && !isMissingKeyword && (
          _react2.default.createElement('span', { className: "settings--org-info--stop-line--reason", __self: this, __source: {fileName: _jsxFileName, lineNumber: 112}},  blocker )
        )
      )
    )
  )
}





// Admin-only: the parent renders it only for org admins, and the server
// refuses both commands for anyone else.
const StopLineSection = ({ orgKey }) => {
  const { setting, hasLoadFailed, save } = _useOrgSMSStopLine.useOrgSMSStopLine.call(void 0, orgKey)
  const titleId = _react.useId.call(void 0, )

  return (
    _react2.default.createElement('section', { className: "settings--org-info--stop-line", 'aria-labelledby': titleId, __self: this, __source: {fileName: _jsxFileName, lineNumber: 130}}
      , _react2.default.createElement('h3', { id: titleId, className: "settings--org-info--stop-line--title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 131}}, "Text message opt-out line"

      )
      , _react2.default.createElement('span', { className: "settings--org-info--hint", __self: this, __source: {fileName: _jsxFileName, lineNumber: 134}}, "Added once to the first text each patient gets from each of your numbers, including patients you were already texting. While it's off, no text gets it; turn it back on and the next first text does. Patients can always reply STOP."




      )
      ,  hasLoadFailed && (
        _react2.default.createElement('span', { className: "settings--org-info--stop-line--error", __self: this, __source: {fileName: _jsxFileName, lineNumber: 141}}, "Couldn't load this setting. Reload the page to try again."

        )
      )
      ,  setting && _react2.default.createElement(StopLineEditor, { setting: setting, onSave: save, __self: this, __source: {fileName: _jsxFileName, lineNumber: 145}} ) 
    )
  )
}

exports. default = _react.memo.call(void 0, StopLineSection)
